import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import SvgLogo from '../generated/svg/logo'
import SvgInstagramIcon from '../generated/svg/instagram-icon'
import SvgXIcon from '../generated/svg/x-icon'
import SvgBag from '../generated/svg/bag'
import SvgPerson from '../generated/svg/person'
import { pageMaxWidth } from '../styles/page-max-width'
import { pxr } from '../styles/pxr'

const Outer = styled.div`
  padding-top: 10rem;
  padding-bottom: 5rem;
  font-family: var(--sans-serif-font);
  font-weight: 400;
  background-color: var(--inverted-bg-color);
  color: var(--inverted-text-color);
  @media (max-width: 60rem){
    
  }
`

const Inner = styled.div`
  ${pageMaxWidth}
  display: grid;
  grid-template-columns: auto;
  @media (max-width: 60rem){
  }
`

const Logo = styled.div`
  grid-area: 1 / 1;
  margin-right: 2rem;
  @media (max-width: 60rem){
  }
  svg {
    display: block;
    height: 3.4375rem;
    width: auto;
    @media (max-width: 60rem){
      height: 2rem;
    }
  }
`

const SnsIconContainer = styled.div`
  display: flex;
  gap: 1.875rem;
  grid-area: 2 / 1;
  @media (max-width: 60rem){
    grid-area: 2 / 1;
    margin-top: 1rem;
  }
`

const SnsIconItem = styled.a`
  display: block;
  @media (max-width: 60rem){
    
  }
  transition: opacity 0.4s;
  &:hover {
    opacity: 0.5;
  }
  svg {
    display: block;
    height: 1.625rem;
    width: auto;
    @media (max-width: 60rem){
      height: 1.25rem;
    }
  }
`

const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-area: 1 / 2 / span 2;
  width: fit-content;
  height: fit-content;
  gap: 2rem 3.5rem;
  @media (max-width: 60rem){
    grid-area: 3 / 1;
    margin-top: 3rem;
  }
`

const NavItem = styled.a`
  display: block;
  width: fit-content;
  transition: opacity 0.4s;
  &:hover {
    opacity: 0.5;
  }
  @media (max-width: 60rem){
    
  }
`

const EnLabel = styled.div`
font-size: 0.875rem;
line-height: 1;
letter-spacing: 0.07em;
@media (max-width: 60rem){
  
}
`

const JaLabel = styled.div`
font-size: 0.5625rem;
line-height: 1.4444444444444444;
letter-spacing: 0.05em;
margin-top: 0.25rem;
@media (max-width: 60rem){
  
}
`

const NavContainer = styled.div`
  gap: ${pxr(38)};
  grid-area: 1 / 3 / span 2;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (max-width: 60rem){
    grid-area: 4 / 1;
    margin-top: 3rem;
  }

`

const NavLink = styled.a`
  font-size: 0.75rem;
  line-height: 1;
  @media (max-width: 60rem){
    
  }
`

const Copyright = styled.div`
  font-size: 0.875rem;
  grid-area: 3 / 1;
  @media (max-width: 60rem){
    grid-area: 5 / 1;
    margin-top: 3rem;
  }
`

type FooterProps = {

}
export const Footer: FunctionComponent<FooterProps> = () => {
  return <Outer>
    <Inner>
      <Logo>
        <SvgLogo />
      </Logo>
      <SnsIconContainer>
        <SnsIconItem href="https://instagram.com/teaflex_jp" target="_blank">
          <SvgInstagramIcon />
        </SnsIconItem>
        {/* <SnsIconItem>
          <SvgXIcon />
        </SnsIconItem> */}
      </SnsIconContainer>
      <Container>
        <NavItem href="/products">
          <EnLabel>
            PRODUCTS
          </EnLabel>
          <JaLabel>
            商品一覧
          </JaLabel>
        </NavItem>
        <NavItem href="/concept">
          <EnLabel>
            ABOUT US
          </EnLabel>
          <JaLabel>
            Teaflexについて
          </JaLabel>
        </NavItem>
        <NavItem href="/feature">
          <EnLabel>
            FEATURE
          </EnLabel>
          <JaLabel>
            お茶の魅力
          </JaLabel>
        </NavItem>
        <NavItem href="/news">
          <EnLabel>
            NEWS
          </EnLabel>
          <JaLabel>
            お知らせ
          </JaLabel>
        </NavItem>
        <NavItem href="/faq">
          <EnLabel>
            FAQ
          </EnLabel>
          <JaLabel>
            よくあるご質問
          </JaLabel>
        </NavItem>
      </Container>
      <NavContainer>
        <NavLink href="https://stoked-store.jp/shop/base_info">会社概要</NavLink>
        <NavLink href="https://stoked-store.jp/shop/customer_term">利用規約</NavLink>
        <NavLink href="https://stoked-store.jp/shop/law_info">特定商取引法に基づく表記</NavLink>
        <NavLink href="https://stoked-store.jp/shop/privacy">プライバシーポリシー</NavLink>
      </NavContainer>
      <Copyright>
        Teaflex © All rights reserved
      </Copyright>
    </Inner>
  </Outer>
}